import { render, staticRenderFns } from "./ui-message.vue?vue&type=template&id=e7abd18c&"
import script from "./ui-message.vue?vue&type=script&lang=js&"
export * from "./ui-message.vue?vue&type=script&lang=js&"
import style0 from "./ui-message.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports